export default function CTASection() {
  return (
    <section id="play" className="relative w-full py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20warm%20golden%20abstract%20gradient%20background%20with%20soft%20geometric%20patterns%20inspired%20by%20traditional%20Chinese%20art%2C%20rich%20burgundy%20and%20gold%20accents%2C%20minimalist%20design%2C%20luxurious%20atmosphere%2C%20smooth%20textures%2C%20warm%20inviting%20feeling%2C%20high%20quality%20artistic%20render&width=1800&height=700&seq=cta-bg-majiang&orientation=landscape"
          alt="开始游戏背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开始搓麻将了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-xl mx-auto">
          无需注册，无需下载，打开浏览器即刻畅玩。加入数百万麻将爱好者的行列，体验最纯粹的麻将乐趣！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            立即免费开玩
          </a>
          <a
            href="#faq"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 backdrop-blur-md text-background-50 rounded-full text-base font-medium border border-background-50/25 hover:bg-background-50/20 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            了解更多
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-5 md:gap-8">
          {[
            { value: '500万+', label: '注册用户' },
            { value: '12+', label: '麻将玩法' },
            { value: '99.9%', label: '服务稳定性' },
            { value: '4.9', label: '用户评分' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-heading font-bold text-accent-400">
                {stat.value}
              </div>
              <div className="text-xs text-background-50/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}